import { appendBubbleFormatClassName } from './messageBubbleClassUtils';
import { formatAdminDisplayName } from '../../../../utils/adminDisplayName';
import { CHAT_BUBBLE_TONE, CHAT_ROW_SIDE } from './chatMessagePresentationUtils';

export function buildEventMessageRowMeta({
  message,
  isAnnouncement = false,
  isMyMessage = false,
  hideSenderMeta = false,
  shouldSubtractSelfRead = true,
  getAnnouncementSenderName,
  senderNameFallback = '',
  announcementSide = CHAT_ROW_SIDE.left,
  selfSide = CHAT_ROW_SIDE.right,
  otherSide = CHAT_ROW_SIDE.left,
  bubbleClassByType = {
    announcement: CHAT_BUBBLE_TONE.announcement,
    self: CHAT_BUBBLE_TONE.right,
    other: CHAT_BUBBLE_TONE.left,
  },
}) {
  const safeMessage = message || {};
  const rowSide = isAnnouncement
    ? announcementSide
    : (isMyMessage ? selfSide : otherSide);
  const senderName = safeMessage.isAdminMsg
    ? formatAdminDisplayName({
        adminDisplayName: safeMessage.admin_display_name || '',
        fullName: safeMessage.admin_full_name || '',
        username: safeMessage.admin_username || '',
        role: safeMessage.admin_role || '',
        isExternalAccount: safeMessage.admin_is_external_account === true,
        externalAffiliationName: safeMessage.admin_external_affiliation_name || '',
        useAsciiParentheses: true,
      })
    : (safeMessage.artist_name || senderNameFallback);
  const announcementSender = isAnnouncement && typeof getAnnouncementSenderName === 'function'
    ? (getAnnouncementSenderName(safeMessage) || senderName)
    : senderName;

  const rawReadCount = Number(safeMessage.read_count) || 0;
  const readOffset = shouldSubtractSelfRead ? 1 : 0;
  const displayReadCount = Math.max(0, rawReadCount - readOffset);

  const bubbleClassName = appendBubbleFormatClassName(
    isAnnouncement
      ? bubbleClassByType.announcement
      : (isMyMessage ? bubbleClassByType.self : bubbleClassByType.other),
    safeMessage.message_format,
  );

  return {
    rowSide,
    isSelfRow: rowSide === selfSide,
    isAdminSender: Boolean(safeMessage.isAdminMsg),
    senderText: hideSenderMeta ? '' : announcementSender,
    partWrapped: '',
    displayReadCount,
    bubbleClassName,
  };
}
